import LessonPage from "../../../../components/LessonPage";

export default function GhoranPage5() {
  const sections = [
    {
      label: "درس ۱",
      points: 120,
      items: [
        { title: "مرور", icon: "📘", link: "/review1", image: "/img1.png" },
        { title: "تمرین", icon: "🧩", link: "/practice1", image: "/img2.png" },
      ],
    },
    {
      label: "درس ۲",
      points: 90,
      items: [
        { title: "ویدئو", icon: "🎥", link: "/video2", image: "/img3.png" },
        { title: "آزمون", icon: "📝", link: "/quiz2", image: "/img4.png" },
      ],
    },
  ];

  return (
    <LessonPage
      title="قران کلاس پنجم"
      sections={sections}
      onClose={() => window.history.back()}
    />
  );
}